import {
    MarketType,
    languageIsoLocales,
    marketIsoLocales,
    marketLocales,
    markets,
    marketsList,
} from 'constants/markets';
import { IsoLocaleType } from 'types/IsoLocaleType';
import { LocaleType } from 'types/LocaleType';

export class InvalidMarketError extends Error { }

export default class MarketHelper {
    public static getBackendDomain(market: MarketType) {
        return markets[market].backendDomain;
    }

    public static isValidMarket(market: string): market is MarketType {
        const marketVerified = market;

        return marketsList.includes(marketVerified);
    }

    public static isValidLocale(locale: string): locale is LocaleType {
        const localeVerified = locale;

        return marketLocales.includes(localeVerified);
    }

    public static formatMarket(market: string): MarketType {
        const marketFormatted = market.toLowerCase();

        if (!MarketHelper.isValidMarket(marketFormatted)) {
            return markets.se.market;
        }

        return marketFormatted as MarketType;
    }

    public static marketToLocale(market: MarketType) {
        return markets[market].locale;
    }

    public static marketToIsoLocale(market: MarketType) {
        return markets[market].isoLocale;
    }

    public static localeToIsoLocale(locale: string) {
        return markets[MarketHelper.localeToMarket(locale)].isoLocale;
    }

    public static ensureLocaleType(locale: string): LocaleType {
        if (!marketLocales.some((marketLocale) => marketLocale === locale)) {
            return 'sv-SE';
        }

        return locale as LocaleType;
    }

    public static ensureIsoLocaleType(isoLocale: string): IsoLocaleType {
        if (!marketIsoLocales.some((marketIsoLocale) => marketIsoLocale === isoLocale)) {
            return 'sv_SE';
        }

        return isoLocale as IsoLocaleType;
    }

    public static ensureLanguageIsoLocaleOrEmptyString(isoLocale?: string) {
        return languageIsoLocales.includes(isoLocale ?? '')
            ? isoLocale
            : '';
    }

    public static localeToMarket(locale: string) {
        return Object.values(markets).find(
            (market) => market.locale === locale || market.market === locale,
        )?.market || markets.se.market;
    }

    public static isoLocaleToMarket(isoLocale: string) {
        return Object.values(markets).find(
            (market) => market.isoLocale === isoLocale || market.market === isoLocale,
        )?.market || markets.se.market;
    }

    public static getOrganisationPaymentMethods(market: MarketType): readonly string[] {
        return markets[market].organisationPaymentMethods;
    }
}
